import { render, staticRenderFns } from "./UsoCientifico.vue?vue&type=template&id=2d8339b0"
import script from "./UsoCientifico.vue?vue&type=script&lang=js"
export * from "./UsoCientifico.vue?vue&type=script&lang=js"
import style0 from "./UsoCientifico.vue?vue&type=style&index=0&id=2d8339b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports